export const heroData = {
  infoCards: [
    {
      userImage: "assets/users/Jane.webp",
      amount: 500,
      sideTitle: "Saved!",
      userName: "Jane",
      purpose: "I switched to a new insurer and saved hundreds of dollars!",
    },
    {
      userImage: "assets/users/Chris.webp",
      amount: 29.99,
      sideTitle: "/mo.",
      userName: "Chris",
      purpose: "I was paying $89.00/mo. and within a few minutes got a much lower quote",
    },
    {
      userImage: "assets/users/Mia.webp",
      amount: 900,
      sideTitle: "Saved!",
      userName: "Mia",
      purpose: "I could not believe I was overpaying so much for my current policy! ",
    },
  ],
};
